import type { Components, Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

const MuiTypography: Components<Theme>['MuiTypography'] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {},
}

// ----------------------------------------------------------------------

export const typography = { MuiTypography }
